import { Routes } from '@angular/router';
import {FuseLoginComponent} from '@modules/authentication/core/login/login.component';
import {BasicPageListAsCardsComponent} from 'fuse-core/components/basic-page/basic-page-list-as-cards/basic-page-list-as-cards.component';
import {FullPageComponent} from 'fuse-core/components/basic-page/full-page/full-page.component';
import {DefaultRouteComponent} from 'fuse-core/components/default-route/default-route.component';
import {HomePageComponent} from 'fuse-core/components/home-page/home-page.component';
import {InformationsLegalesComponent} from 'fuse-core/components/informations-legales/informations-legales.component';
import {IsAllowedBySettings, IsUserAnonymous, IsUserLogged} from '../../../../src/app/guards';

export const routes: Routes = [
{
        path: '',
        component: DefaultRouteComponent,
        canActivate: [IsUserLogged, IsAllowedBySettings],
    },
    {
        path: 'home',
        component: HomePageComponent,
        canActivate: [IsUserLogged],
    },
    {
        path: 'further',
        canActivate: [IsUserLogged, IsAllowedBySettings],
        children: [
            {
                path: ':alias',
                component: HomePageComponent,
                canActivate: [IsAllowedBySettings],
            }
        ]
    },
    {
        title: 'aventure',
        path: 'page/aventure',
        component: FullPageComponent,
        canActivate: [IsUserLogged, IsAllowedBySettings]
    },
    {
        path: 'page/:alias',
        component: FullPageComponent,
        canActivate: [IsAllowedBySettings],
    },
    {
        path: 'informations-legales',
        component: InformationsLegalesComponent,
        canActivate: [IsAllowedBySettings],
    },
    {
        path: 'page-as-card-list/:alias',
        component: BasicPageListAsCardsComponent,
        canActivate: [IsAllowedBySettings],
    },
    {
        path: 'collection',
        canActivate: [IsAllowedBySettings],
        loadChildren: () => import('@fuse/components/collection/collection.module').then(m => m.CollectionModule),
    },
    {
        path: 'maintenance',
        loadComponent: () => import('../../../../src/app/maintenance/maintenance.component').then(m => m.MaintenanceComponent),
    },
    {
        path: 'corpus', // The base path for all routes inside CorpusModule
        loadChildren: () => import('@modules/corpus/core/corpus.module').then(m => m.CorpusModule), // Corrected path using alias
        canActivate: [IsUserLogged] // Apply guards needed for the whole module access
    },
    {
        path: 'groups',
        loadChildren: () => import('@modules/groups-management/core/groups-management.module').then(m => m.GroupsManagementModule),
        canActivate: [IsUserLogged] // Base guard, specific guards are in the child module
    },
    {
        path: 'followed', // Chemin pour accéder au module lazy-loadé
        loadChildren: () => import('@modules/assignation/core/assignation.module').then(m => m.AssignationModule),
        canActivate: [IsUserLogged] // Gardien appliqué avant le chargement
    },
    {
        path: 'login',
        component: FuseLoginComponent,
        canActivate: [IsUserAnonymous]
    },
    {
        path: 'code',
        loadChildren: () => import('@modules/gamecode/core/gamecode.module').then(m => m.GamecodeModule)
    },
    {
        path: 'forgot-password',
        loadComponent: () => import('@modules/authentication/core/forgot-password/forgot-password.component').then(m => m.FuseForgotPasswordComponent),
    },
    {
        path: 'forgot-password/:params',
        loadComponent: () => import('@modules/authentication/core/forgot-password/forgot-password.component').then(m => m.FuseForgotPasswordComponent),
    },
    {
        path: 'user/reset/:token',
        loadComponent: () => import('@modules/authentication/core/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    },
    {
        path: 'user/reset/:token/origin/:origin',
        loadComponent: () => import('@modules/authentication/core/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    },
    {
        path: 'password-reset-email',
        loadComponent: () => import('@modules/authentication/core/password-reset-email/password-reset-email.component').then(m => m.FusePasswordResetEmailComponent),
    }
];
